import { create } from "zustand";

export const useFolderStore = create((set) => ({
  isShowFolders: true,
  setIsShowFolders: (isShowFolders: boolean) =>
    set({ isShowFolders: isShowFolders }),
  folderData: [],
  setFolderData: (folderData: any) => set({ folderData: folderData }),
  selectedFolder: null,
  setSelectedFolder: (selectedFolder: any) =>
    set({ selectedFolder: selectedFolder }),
  folderId: null,
  setFolderId: (folderId: any) => set({ folderId: folderId }),
  breadcrumbPath: [],
  setBreadcrumbPath: (path: any) => set({ breadcrumbPath: path }),
  isShowNewFolder: false,
  setIsShowNewFolder: (isShowNewFolder: boolean) =>
    set({ isShowNewFolder: isShowNewFolder }),
  folderName: "All Media",
  setFolderName: (folderName: any) => set({ folderName: folderName }),
  isRenameSuccess: false,
  setIsRenameSuccess: (isRenameSuccess: boolean) =>
    set({ isRenameSuccess: isRenameSuccess }),
  isCreateSuccess: false,
  setIsCreateSuccess: (isCreateSuccess: boolean) =>
    set({ isCreateSuccess: isCreateSuccess }),
  openedNodes: [1],
  setOpenedNodes: (openedNodes: any) => set({ openedNodes: openedNodes }),
  isDeleteSuccess: false,
  setIsDeleteSuccess: (isDeleteSuccess: boolean) =>
    set({ isDeleteSuccess: isDeleteSuccess }),
  isMoveSuccess: false,
  setIsMoveSuccess: (isMoveSuccess: boolean) =>
    set({ isMoveSuccess: isMoveSuccess }),
  previousFolderName: null,
  setPreviousFolderName: (previousFolderName: any) =>
    set({ previousFolderName: previousFolderName }),
  previousFolderId: null,
  setPreviousFolderId: (previousFolderId: any) =>
    set({ previousFolderId: previousFolderId }),
  isShowMoveFolder: false,
  setIsShowMoveFolder: (isShowMoveFolder: boolean) =>
    set({ isShowMoveFolder: isShowMoveFolder }),
  selectedFolderId: null,
  setSelectedFolderId: (selectedFolderId: any) =>
    set({ selectedFolderId: selectedFolderId }),
  isFolderMoveSuccess: false,
  setIsFolderMoveSuccess: (isFolderMoveSuccess: boolean) =>
    set({ isFolderMoveSuccess: isFolderMoveSuccess }),
  selectedId: null,
  setSelectedId: (selectedId: any) => set({ selectedId: selectedId }),
  isShowRename: false,
  setIsShowRename: (isShowRename: boolean) =>
    set({ isShowRename: isShowRename }),
  isShowDelete: false,
  setIsShowDelete: (isShowDelete: boolean) =>
    set({ isShowDelete: isShowDelete }),
  openFolderName: "All Media",
  setOpenFolderName: (openFolderName: any) =>
    set({ openFolderName: openFolderName }),
}));
